import React from "react";
import "./privacy.css";
import InnerBanner from "../components/InnerBanner";
import serviceBg from "../assets/FFO+.jpeg";
import { color } from "chart.js/helpers";

const Terms = () => {
  return (
    <div className="privacy-wrapper">
      <div className="privacy-container">
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <InnerBanner title="Terms & Conditions" bgImage={serviceBg} />

        <br />
        <br />

        <h1 className="privacy-title">
          Terms & Conditions – Servizy Mobile Repair
        </h1>
      
          <ul>
            <li><strong>Effective Date:</strong> 26 March 2026</li>
            <li><strong>Business Name:</strong> Servizy – Mobile Service & Repair</li>
            <li><strong>Address:</strong> Rajajinagar, Bengaluru</li>
            <li><strong>Contact:</strong> 99900 99900</li>
          </ul>
        

        <p>
          By booking or using Servizy’s services, you agree to the following terms:
        </p>

        <h2>1. Nature of Service</h2>
        <ul>
          <li>Servizy provides doorstep and onsite mobile repair services for smartphones.</li>
          <li>We operate as an independent repair service provider and are not affiliated, authorized, or endorsed by any brand or manufacturer.</li>
        </ul>

        <h2>2. Service Process</h2>
        <ul>
          <li>Repairs are conducted at the customer’s location or designated service point.</li>
          <li>Service time may vary depending on the issue and availability of spare parts.</li>
        </ul>

        <h2>3. Spare Parts</h2>
        <ul>
          <li>We use compatible, high-quality or OEM-grade parts based on availability.</li>
          <li>Customers will be informed about the type and cost of parts before proceeding.</li>
        </ul>

        <h2>4. Warranty</h2>
        <ul>
          <li>Limited warranty (e.g., 30–90 days) may be provided on selected repairs.</li>
          <li>Warranty applies only to the specific repaired component.</li>
          <li>Warranty is void if:</li>
          <ul>
            <li>Device is physically damaged after repair</li>
            <li>Device is opened or repaired by another technician</li>
            <li>Liquid damage occurs after service</li>
          </ul>
        </ul>

        <h2>5. Customer Responsibility</h2>
        <ul>
          <li>Customers must backup all data before service.</li>
          <li>Servizy is not responsible for data loss, corruption, or privacy issues during repair.</li>
        </ul>

        <h2>6. Pricing & Payment</h2>
        <ul>
          <li>Pricing will be shared before service confirmation.</li>
          <li>Payments must be completed immediately after service unless agreed otherwise.</li>
        </ul>

        <h2>7. Liability</h2>
        <ul>
          <li>Servizy is not liable for:</li>
          <ul>
            <li>Pre-existing device issues</li>
            <li>Indirect or consequential damages</li>
          </ul>
          <li>Maximum liability is limited to the service amount paid.</li>
        </ul>

        <h2>8. Service Availability</h2>
        <ul>
          <li>Doorstep service availability depends on location, technician availability, and service scope.</li>
        </ul>

        <h2>9. Governing Law</h2>
        <ul>
          <li>These terms are governed by the laws of India. Jurisdiction: Bengaluru courts.</li>
        </ul>

      
<br/>
        <h1 style={{ color: "#1E88E5" }}>💰Refund & Cancellation Policy – Servizy</h1>
<br/>
        <p><strong>Effective Date:</strong> 26 March 2026</p>

        <h2>1. Cancellation Policy</h2>
        <ul>
          <li>Service can be canceled before technician dispatch for a full refund (if advance paid).</li>
          <li>If canceled after technician arrival, a visiting/inspection charge may apply.</li>
        </ul>

        <h2>2. Refund Policy</h2>
        <ul>
          <li>If the repair cannot be completed, a full or partial refund will be issued depending on work done.</li>
          <li>No refunds once the service is completed and accepted by the customer.</li>
        </ul>

        <h2>3. Refund Timeline</h2>
        <ul>
          <li>Refunds will be processed within 7–10 working days to the original payment method.</li>
        </ul>

        <h2>4. Non-Refundable Charges</h2>
        <ul>
          <li>Inspection/diagnostic charges</li>
          <li>Cost of special-order or installed spare parts</li>
        </ul>

      </div>
    </div>
  );
};

export default Terms;